<template>
    <section class="title-map-list-toggle component-header" id="title-map-list-toggle">
        <h1 v-if="title" class="headline-1">{{ title }}</h1>
        <slot />
    </section>
</template>

<script setup>
    const props = defineProps({
        title: {
            type: String,
            required: true,
            default: '',
        },
        subtitle: {
            type: String,
            required: false,
        },
        year: {
            type: String,
            required: false,
        },
    });
</script>

<style lang="scss">
    .title-map-list-toggle {
        padding: 20px 8px;

        &.component-header {
            margin-bottom: 0;
            flex-direction: row;
        }

        .headline-2 {
            margin-top: 12px;
        }

        .view-buttons {
            display: flex;

            .view-button {
                margin-left: 15px;

                &.map-folded {
                    path,
                    line {
                        stroke: $gray-common;
                        transition: stroke 0.25s ease-in-out;
                    }

                    .active {
                        path,
                        line {
                            stroke: $black;
                            transition:
                                stroke 0.25s ease-in-out,
                                fill 0.25s ease-in-out;
                        }
                    }
                }

                &.list {
                    .svg {
                        circle,
                        path,
                        line {
                            stroke: $gray-common;
                            fill: $gray-common;
                            transition:
                                stroke 0.25s ease-in-out,
                                fill 0.25s ease-in-out;
                        }

                        &.active {
                            circle,
                            path,
                            line {
                                stroke: $black;
                                fill: $black;
                                transition: stroke 0.25s ease-in-out;
                            }
                        }
                    }
                }
            }
        }

        @media (min-width: $tablet) {
            position: relative;

            &.component-header {
                padding: 40px 16px 20px;
                margin: 0 0 0;
            }

            .headline-1 {
                font-size: 3.5rem;
            }

            .view-buttons {
                .view-button {
                    width: 100%;
                    height: 100%;
                    
                    &:not(:last-child) {
                        margin-right: 20px;
                    }

                    svg {
                        width: 30px;
                        height: 30px;
                    }
                }
            }
        }

        @media (min-width: $desktop) {
            &.component-header {
                padding: 0px 8px 20px;
            }
        }
    }
</style>
